import React from 'react'
import PropTypes from 'prop-types'
import ThreeSixtyViewer from '../../3_Organisms/360Viewer/360Viewer'
import CalloutBoxShort from '../../2_Molecules/CalloutBox/CalloutBoxShort';
import { languageController } from '../../../controllers/language/languageController';

function ConfirmationStep({
  vehicleData,
  dateAndTime,
  dealerData,
  contactDetails,
}) {
  const { dealer: selectedDealerData, userPosition } = dealerData || {};

  return (
    <div className="mz-confirmation-step">
      <div className="mz-container">
        <div className="mz-full-width">

          <div className="mz-confirmation-step__top">
            <h3>{languageController.getCopy('confirmationStep', 'title')}, {contactDetails?.firstname}!</h3>
            <p>{languageController.getCopy('confirmationStep', 'subTitle')}</p>
          </div>

          <div className="mz-confirmation-step__main">
            <div className="mz-confirmation-step__360">
              <ThreeSixtyViewer
                exteriorImages={demoExternalImages} // tmp
                interiorPanoramaImage={'http://localhost:6006/static/tempImgs/image360/interior-black.jpg'} // tmp
              />
            </div>
            <div className="mz-confirmation-step__callout">
              <CalloutBoxShort
                vehicleData={vehicleData}
                dealerData={selectedDealerData}
                userPosition={userPosition}
                dateAndTimeData={dateAndTime}
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

const demoExternalImages = [
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-33.png",
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-34.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-35.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-36.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-37.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-38.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-39.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-40.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-41.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-42.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-43.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-44.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-45.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-46.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-47.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-48.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-01.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-02.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-03.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-04.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-05.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-06.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-07.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-08.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-09.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-10.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-11.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-12.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-13.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-14.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-15.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-16.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-17.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-18.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-19.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-20.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-21.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-22.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-23.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-24.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-25.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-26.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-27.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-28.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-29.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-30.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-31.png"
  },
  {
    src: "http://localhost:6006/static/tempImgs/images-rotator/black/car-black-32.png"
  },
];

ConfirmationStep.propTypes = {
  vehicleData: PropTypes.object,
  dateAndTime: PropTypes.object,
  dealerData: PropTypes.object,
  contactDetails: PropTypes.object,
}

export default ConfirmationStep